export default {
  common: {
    noData: "暂无数据",
  },
  nav: {
    home: "首页",
    about: "关于坤时",
    solution: "解决方案&核心技术",
    news: "动态中心",
    contact: "联系我们",
    search: "搜索",
  },
  news: {
    title: "动态中心",
    subtitle: "NEWS CENTER",
    more: "探索更多",
    readMore: "阅读全文",
    list: [
      {
        title: '北部湾港"王牌设备"表现超吸睛',
        desc: '近日，北部湾港防城港码头传来喜讯，由科思科技自主研发的自动化散货卸船机在铝土矿卸船作业中创下新纪录，单机效率达到1626吨/小时，比传统人工操作效率提升10%，成为国内首台超越人工效率的同类型散货自动化卸船机。',
        date: "2025-04-18",
        url: "/news/57",
      },
      {
        title: '智慧煤场"技能树"已点满！一探究竟！',
        desc: "你以为的煤场是这样的：取料要有人，转堆要有人，开堆要有人，巡检要有人。但现在的智慧煤场已经实现了全自动化，系统通过在堆取料机上安装定位传感器、雷达料位计、雷达防撞传感器等设备，与无人值守系统PLC等电控系统相配合，甭管白天黑夜，都能精神抖擞，24小时感知料场设备实时动态。",
        date: "2025-01-15",
        url: "/news/55",
      },
      {
        title: "科技成果 | 浙江公司宁海电厂智能煤场成果获节能减排技术创新奖",
        desc: '11月22日，浙江公司宁海电厂"3、4号圆形煤场智能管控系统研究与应用"成果荣获中国节能协会颁布的节能减排技术创新二等奖。该成果围绕电力新形势下智能发电企业建设，从科技创新、节能增效、人文健康多角度出发，创新提出了通过搭建一套标准化程度高、功能全面且系统开放性强的智能管控系统，实现煤场煤堆3D数字化管理，达到节能增效的目的。',
        date: "2024-11-27",
        url: "/news/56",
      },
      {
        title: "发电厂如何减少碳排放？",
        desc: "中国将在2060年前实现碳中和。作为中国最大的发电企业之一，华能集团是为实现这一目标铺平道路的关键参与者之一。智能和绿色倡议促使像华能这样的发电厂从传统的烟囱企业转型。",
        date: "2021-11-25",
        url: "/news/53",
      },
    ],
    article56: {
      title: "科技成果 | 浙江公司宁海电厂智能煤场成果获节能减排技术创新奖",
      date: "2024-11-27",
      preview:
        '11月22日，浙江公司宁海电厂"3、4号圆形煤场智能管控系统研究与应用"成果荣获中国节能协会颁布的节能减排技术创新二等奖。该成果围绕电力新形势下智能发电企业建设，从科技创新、节能增效、人文健康多角度出发，创新提出了通过搭建一套标准化程度高、功能全面且系统开放性强的智能管控系统，实现煤场煤堆3D数字化管理，达到节能增效的目的。',
      readMore: "在微信中阅读完整文章",
      content: {
        title: "科技成果 | 浙江公司宁海电厂智能煤场成果获节能减排技术创新奖",
        date: "2024-11-27",
        text: [
          '11月22日，浙江公司宁海电厂"3、4号圆形煤场智能管控系统研究与应用"成果荣获中国节能协会颁布的节能减排技术创新二等奖。该成果围绕电力新形势下智能发电企业建设，从科技创新、节能增效、人文健康多角度出发，创新提出了通过搭建一套标准化程度高、功能全面且系统开放性强的智能管控系统，实现煤场煤堆3D数字化管理，达到节能增效的目的。',
          '在该项成果的研究中，技术人员根据设备运行工况结合司机操作经验，研发出一键移车路径寻优、一键智能开堆、恒流取料智能掺配及滑环温度监测等多项成果，实现了圆形煤场堆取料机自动取料、堆料、开堆、转堆、补堆等堆取料全过程作业无人值守，以及自动盘煤和精准配煤。该系统在投入生产以后，有效提升了煤场管理的智能化水平及生产效率，达到节能增效目的。一直以来，在集团公司"41663"总体工作方针的引领下，该厂在扎实做好能源保供的同时，大力推动以"火电＋"为一体的数智化创效发展，该成果的落地有效实现了发电企业降本增效，助力节能减碳，在"双碳"目标下具有广泛的推广前景。',
        ],
        credits: {
          title: "项目团队",
          members: [
            "项目负责人：张工",
            "技术总监：李工",
            "系统架构师：王工",
            "现场实施：刘工",
            "技术支持：陈工",
          ],
        },
      },
    },
    article55: {
      title: '智慧煤场"技能树"已点满！一探究竟！',
      date: "2025-07-24",
      preview:
        "你以为的煤场是这样的：取料要有人，转堆要有人，开堆要有人，巡检要有人。但现在的智慧煤场已经实现了全自动化...",
      readMore: "查看详情",
      content: {
        title: '智慧煤场"技能树"已点满！一探究竟！',
        date: "2025-07-24",
        traditionalCoalYard: {
          title: "你以为的煤场是这样的",
          features: ["取料要有人", "转堆要有人", "开堆要有人", "巡检要有人"],
        },
        smartPlatform: {
          intro: [
            "不如来国家能源集团浙江公司宁海电厂",
            "看看圆形煤场智能管控平台",
            "所有问题只要动动手指就轻松解决",
            "一起感受下如此炫酷的平台吧",
          ],
          description: [
            "圆形煤场智能管控平台由",
            "宁海电厂邓建国创新工作室自主研发",
            "该智能管控平台以3D形式展示通过在圆形煤场安装",
            "激光扫描仪 高精度云台设备 结合CPU控制单元等设备",
            "实现多种数据的实时采集 高速计算 数据交换与融合",
            '15项技能和多个"隐藏"功能 解决圆形煤场生产管理与堆取作业',
            "控制核心业务需求",
            "简化生产管理模式 实现数字孪生",
            "快来Pick一款你最喜欢的技能吧！",
          ],
        },
        skills: {
          skill1: {
            title: "技能1：24小时智能在线管家",
            description: [
              "又称无人值守系统。该系统通过在堆取料机上安装定位传感器、雷达料位计、雷达",
              "防撞传感器等设备，与无人值守系统PLC等电控系统相配合，甭管白天黑夜，都能",
              "精神抖擞，24小时感知料场设备实时动态。",
            ],
          },
          skill2: {
            title: "技能2：智能导航泊车助手",
            description: [
              "又称路径寻优智能移车。过去，传统移车费时又费力。现在只要下发一键移车任务指",
              "令，系统自动规划最优路径，就像装了GPS导航一样精准！",
            ],
          },
          skill3: {
            title: "技能3：无人驾驶小超人",
            description: [
              '又称一键智能开堆。原来开堆像在山路开车，司机们开得小心翼翼。现在，"小超人"',
              "一键启动，智能分析，料堆表面瞬间变得平平整整，精准高效，零风险、零失误。",
            ],
          },
          skill4: {
            title: "技能4：精准配比的五星大厨",
            description: [
              "又称智能掺配系统。曾经，智能掺配凭感觉。现在，精准控制取料流量，恒定比例轻",
              "松get！PID运算加持，物料掺配科学又高效！",
            ],
          },
          skill5: {
            title: "技能5：裸眼3D电影",
            description: [
              "又称数字化3D煤场。原来，系统堆取料机及煤场料堆都是平面，煤场情况不能动态",
              "变化。现在，整体以3D形式展示煤场内三维物料形貌。堆取料机的回转、俯仰取料",
              "等动作都能实时展现，简直就像在看3D电影！",
            ],
          },
          skill6: {
            title: "技能6：煤场扫描神器",
            description: [
              "又称一键盘煤系统。原来，1台激光扫描仪+人工手动操作+盘煤30分钟/次。现在，",
              "短短3分钟即可快速盘煤，效率爆表！还能一键更新煤场储量目标，一键精确计算煤",
              "场存煤体积、重量等，这速度、这效率，绝了！",
            ],
          },
          skill7: {
            title: '技能7：煤场里的"地形图"',
            description: [
              "又称煤场二维图。原来，手动绘制煤场图，与实际存在较大差异。现在，系统可以将",
              "煤场划分为若干区域，实现分区分煤种堆放，每次任务结束，能马上对煤场动态盘",
              '煤，"唰"的一下，就生成立体三维煤场图形。量、质、价分析统统不在话下！',
            ],
          },
          additionalSkills: [
            "除了上面这些技能外",
            "还有智能照明 设备测温报警系统",
            "设备运行实时曲线 生命周期管理等技能",
          ],
        },
        achievements: {
          intro: [
            "现如今",
            '这个"技能树"不光科技满满',
            '还"战果"累累',
            "投运后",
          ],
          results: [
            "降低标煤损耗1060吨/年",
            "节省电量37万度/年",
            "降低维护成本30万元/年",
            "提高工作效率33%",
          ],
          conclusion: [
            "这样的新质生产力太香了",
            "安全 节能 高效全搞定",
            "让火电厂变得更高效化 更智能化 更数字化",
            "实力圈粉没商量~",
          ],
        },
      },
    },
    article53: {
      content: {
        title: "发电厂如何减少碳排放？",
        date: "2021-11-24",
        text: [
          "中国将在2060年前实现碳中和。作为中国最大的发电企业之一，华能集团是为实现这一目标铺平道路的关键参与者之一。智能和绿色倡议促使像华能这样的发电厂从传统的烟囱企业转型。",
        ],
        credits: {
          title: "视频制作团队",
          members: [
            "导演兼记者：周艺秋",
            "摄像：郭元亨",
            "视频编辑：周艺秋、王哲",
            "执行制片人：王明燕",
            "总编辑：张万",
          ],
        },
      },
    },
    article57: {
      title: "北部湾港“王牌设备”表现超吸睛",
      date: "2025-04-18",
      preview:
        '近日，防城港企沙港区赤沙作业区2号泊位作业繁忙，北部湾港“王牌设备”——自动化桥式抓斗卸船机表现吸睛，虽是“钢铁巨人”，但每次货物抓取与放下，不仅精准流畅而且迅速平稳，铝土矿卸船单机效率达到1626吨/小时，比传统人工操作效率提升10%，成为国内首台超越人工效率的同类型散货自动化卸船机。自动化桥式抓斗卸船机的成功投运，不仅是北部湾港码头设备大型化与自动化、智能化高效融合的重要尝试，也是全面提升服务质效的又一次生动实践！',
      content: {
        title: "北部湾港“王牌设备”表现超吸睛",
        date: "2025-04-18",
        text: [
          '近日，防城港企沙港区赤沙作业区2号泊位作业繁忙，北部湾港“王牌设备”——自动化桥式抓斗卸船机表现吸睛，虽是“钢铁巨人”，但每次货物抓取与放下，不仅精准流畅而且迅速平稳，铝土矿卸船单机效率达到1626吨/小时，比传统人工操作效率提升10%，成为国内首台超越人工效率的同类型散货自动化卸船机。自动化桥式抓斗卸船机的成功投运，不仅是北部湾港码头设备大型化与自动化、智能化高效融合的重要尝试，也是全面提升服务质效的又一次生动实践！',
          '防城港企沙港区赤沙作业区1-2号泊位是广西最大自动化干散货泊位。为满足高效、环保、智能化的现代物流需求，北部湾港股份及下属赤沙码头业务骨干牵头组建科创攻坚团队，经过充分研判论证，启动实施铝土矿等干散货船舶全流程无人化卸船项目，该项目曾入选交通运输部《2022年度交通运输行业重点科技项目清单》。',
          '攻坚团队紧扣“项目+科创”建设思路，聚焦《桥式抓斗卸船机自动化技术研究与应用》《桥式抓斗卸船机智能抑尘技术研究与应用》等课题深入研究，成功研发“铝土矿自动化卸船工艺”“卸船机AI仿生作业系统”“三维空间多融合技术与动态感知系统”等多项关键技术。“铝土矿自动化卸船工艺”，针对铝土矿的特性，对卸船流程进行优化，大大提高卸船作业效率，同时还能节约资源，减少浪费；“卸船机AI仿生作业系统” ，通过引入先进的仿生算法和智能控制技术，让卸船机能够像生物一样根据环境变化做出智能反应，就像赋予卸船机 “智慧大脑”；“三维空间多融合技术与动态感知系统”，三维融合技术精准建模，毫米级定位破解复杂工况，多模态防护系统全天候护航，大幅升级安全预警能力。同时，还融合了智能抑尘、智能监控系统等超强内核装备，能够有效实现自动化、智能化管控，为打造高效化、绿色化的装卸技术与设备树立了新标杆。根据测算，该项目全面实施后将实现提效创收约3200万元/年。',
          '防城港企沙港区赤沙作业区1-2号泊位是建设西部陆海新通道的重点工程，也是打造北部湾国际门户港和国际枢纽海港的关键项目，不仅创下同类型码头建设效率新纪录，还创造了广西区域码头口岸建设、对外开放及启用用时最快的纪录。当下，自动化桥式抓斗卸船机的成功投运，将极大提升码头装卸效率，有效压缩船舶待（离）泊时间，进一步提升港口周转率，实现码头运营成本和客户物流成本双下降，切实为广西华昇等腹地企业提供高效、优质服务，助推冶金、能源、新材料等临港产业构建稳定供应链体系，以“效率－成本－客源”的良性循环发展，为推动西部陆海新通道建设提质增效和高水平打造北部湾国际门户港注入新活力，助力北部湾港和区域经济高质量发展。',
        ],
      },
    },
  },
  about: {
    title: "关于坤时",
    profile: {
      title: "公司简介",
      p1: "杭州坤时自动化系统有限公司(以下简称杭州坤时)，公司位于浙江杭州，荟鼎智创中心，研发中心位于杭州滨江高新区，面积3000方。杭州坤时是专精特新、国家高新企业。并拥有软件能力成熟度模型集成CMMI3级认证证书、电子与智能化工程专业承包二级、市级研发中心资质。",
      p2: "公司主营产品为散料输送行业无人值守系统、智能燃料管理系统、智能运维系统、智能调度系统、综合能源管理平台、储能系统。并在核心三维视觉超融合控制技术、图像识别技术、AI Agent、具身智能及算法等领域有多年积累经验及应用案例。目前是智慧散料输送行业头部企业。",
      p3: "2023年入选112家浙江省级产业数字化服务商。公司拥有多项自主知识产权，50余项国家专利及软件著作权、软件测评，是中国先进的工业智能系统开发商。",
      p4: "公司与全国多所知名高校建立长期技术合作关系并建有联合研发中心，服务客户多为全国五大电力集团、地方能源集团、全国散货港口、冶金行业(烧结工艺原料场)、化工行业(动力中心)等企业。",
    },
    culture: {
      title: "企业文化",
      values: {
        title: "价值观",
        items: [
          "客户第一",
          "技术要硬",
          "团队要拼",
          "卓越创新",
          "极致执行",
          "持续进化",
        ],
      },
      mission: {
        title: "使命",
        content: "以创新AI技术重塑工业生产力，赋能企业数字化转型",
      },
      vision: {
        title: "愿景",
        content: "引领工业智能化革命，构建机器自主决策的未来",
      },
    },
    history: {
      title: "发展历程",
    },
    honors: {
      title: "荣誉资质",
      desc: "2023年入选112家浙江省级产业数字化服务商。公司拥有多项自主知识产权，50余项国家专利及软件著作权、软件测评，是中国先进的工业智能系统开发商。",
      items: {
        1: { title: "CMMI3认证证书" },
        2: { title: "信息安全管理体系认证证书" },
        3: { title: "质量管理体系证书" },
        4: { title: "环境管理体系证书" },
        5: { title: "浙江省专精特新中小企业证书" },
        6: { title: "国家高新企业证书" },
        7: { title: "杭州市雏鹰企业证书" },
        8: { title: "杭州市高新企业证书" },
        9: { title: "全国智能发电技术创新成果单位" },
        10: { title: "2023年省级产业数字化服务商" },
      },
    },
    partners: {
      title: "合作伙伴",
    },
    core: {
      slogan: "AIoT融合赋能无人值守，数字引擎驱动能源未来",
      stats: [
        { label: "公司成立", unit: "年" },
        { label: "投运项目", unit: "+" },
        { label: "年产值", unit: "万" },
        { label: "合作企业", unit: "+" },
      ],
    },
    historyData: [
      {
        year: "2013",
        title: "公司成立",
        events: ["杭州坤时自动化系统有限公司正式成立"],
      },
      {
        year: "2016",
        title: "飞速发展",
        events: ["独立完成2台斗轮机无人值守", "获得杭州市雏鹰计划企业"],
      },
      {
        year: "2017",
        title: "高新企业",
        events: ["获取高新企业证书"],
      },
      {
        year: "2023",
        title: "企业新程",
        events: ["获得专精特精", "入选112家浙江省级产业数字化服务商"],
      },
      {
        year: "2024",
        title: "技术创新",
        events: ["滨江区建立研发中心", "获得全国智能发电技术大会银牌"],
      },
    ],
  },
  solution: {
    title: "解决方案&核心技术",
    subtitle: "Solution & Core Technology",
    unmanned: {
      title: "散料无人值守解决方案",
      subtitle: "Unattended Solution for Bulk Materials",
      visible: true,
      bucketWheel: {
        title: "斗轮机无人值守系统",
      },
      circularStockyard: {
        title: "圆形料场智能管控系统",
      },
      semiGantry: {
        title: "半门式刮板堆取料机无人值守系统",
      },
      p1: "斗轮机无人值守系统通过数据采集和实时控制，实现煤堆建模、料高检测、煤流检测、防碰撞检测、精确定位、可视化监控等功能，系统可自主运行，并按照设定比例控制多台斗轮机。采用先进的智能控制算法和实时数据处理技术，确保系统安全、高效、稳定运行，降低人工成本。",
      p2: "圆形料场智能管控系统采用激光扫描和高精度定位技术，实现料堆三维建模、料位检测、防碰撞检测、精确定位等功能，系统可自主运行，并按照设定比例控制多台堆取料机。采用先进的智能控制算法和实时数据处理技术，确保系统安全、高效、稳定运行，降低人工成本。",
      p3: "半门式刮板堆取料机无人值守系统通过远程煤控室通信，采用先进的传感器技术，实现料堆建模、料位检测、防碰撞检测、精确定位、可视化监控等功能，系统可自主运行，无需人工干预。采用先进的智能控制算法和实时数据处理技术，确保系统安全、高效、稳定运行，降低人工成本。",
    },
    fuel: {
      title: "燃料智能化解决方案",
      subtitle: "Fuel Intelligence Solutions",
      visible: true,
      p1: "智能流程控制系统是对整个码头、矿石料场、煤场、副原料场及混匀料场进行智能化管理和流程决策，主要包含智能调度系统、智能流程决策系统、作业计划管理、料场信息管理、料仓信息管理、实绩报表管理功能等。智能流程控制系统是对码头内从入口至出口上百条皮带、卸船机、堆取料机、装船机等进行统一管理，结合设备属性，运转成本、设备维修计划等信息，选择最佳流程。",
    },
    unloading: {
      title: "卸船机AI解决方案",
      subtitle: "AI Unloading Solutions",
      visible: true,
      p1: "卸船机全自动控制系统、智能卸船机防摇系统和基于深度推理装卸设备无人值守垂直模型在不改变传统手动操作模式的基础上，对卸船机进行智慧化改造，实现卸船机全自动控制作业。该系统基于激光三维和视觉融合的方式，将数据采集、三维建模、设备控制、船舱管理、生产安全等多个系统融合成一个统一的管控平台。通过三维激光设备与高精度定位结合系统建立码头、卸船机、船舱三位一体的统一三维坐标系，指导卸船机对船舱内的物料进行精确取料，提高工作效率，降低作业人员的劳动强度，提升码头整体作业水平。",
    },
    inspection: {
      title: "皮带巡检解决方案",
      subtitle: "Belt Inspection Solutions",
      visible: true,
      p1: "皮带机智能巡检系统通过不同工作状态、不同时段的数据采集形成皮带机运行数据库同时不断采集和训练AI模型，对异常情况进行及时报警;实现输煤皮带跑偏、撕裂监测、皮带区域人员入侵报警皮带撒料识别，电机振动温度异常报警、托音采集，有毒有害气体及粉尘浓度超标报警等功能;同时搭载设备生命周期管理，运行维护管理以及硬件资料管理为皮带系统的健康运行提供支持，形成整套闭环系统，提高整个输煤线的智能化。",
    },
    coreTech: {
      title: "核心技术",
      subtitle: "Core Technology",
      visible: true,
      p1: "坤时自动化在散料输送行业拥有多项核心技术，包括三维视觉超融合控制技术、图像识别技术、AI Agent、具身智能及算法等。这些技术为我们的解决方案提供了强大的技术支撑，确保系统的高效、稳定运行。",
      vision: {
        title: "三维视觉超融合控制技术",
        desc: "将三维点云数据、图形识别技术、生产设备建立一体化坐标系。通过三维模型精确计算生产对象及生产设备的特征点坐标融入视觉识别技术，将坐标参数接入控制系统，通过大数据分析获取高效的生产控制逻辑，从而控制生产设备执行任务。",
      },
      ai: {
        title: "智能AI识别特征技术",
        desc: "在工业环境下，通过工业摄像头获取现场视频。利用计算机对现场图像进行处理、分析和理解，应用深度学习算法，以识别各种不同模式的目标和对象。对现场数据进行识别并实现数字化采集，给出报警等指示。",
      },
      control: {
        title: "人工智能体",
        desc: "人工智能体（AI Agent），不同于传统的人工智能，其具备通过独立思考、调用工具去逐步完成给定目标的能力。感知环境、进行决策和执行动作的智能实体。应用于散料输送线智能化系统。",
      },
    },
  },
  footer: {
    companyNews: "公司新闻",
    contactInfo: "联系方式",
    hotline: "服务热线",
    workTime: "工作时间：周一至周五 9:00-18:00",
    qrcode: "扫码关注我们",
    copyright: "© 2024 杭州坤时自动化系统有限公司 版权所有",
    icp: "浙ICP备13019724号-1",
  },
  contact: {
    title: "联系方式",
    hotline: "服务热线",
    fax: "传真",
    email: "联系邮箱",
    address: "联系地址",
    addressContent: {
      hq: "浙江省杭州市滨江区乳泉路 826 号（荟鼎智创中心）6 号楼 9-10 层",
    },
  },
  home: {
    vision: "AIoT融合赋能无人值守，数字引擎驱动能源未来",
    banner: {
      title: "构建数字能源智慧中枢，驱动万亿级工业生态高效协同",
      solutions: {
        unmanned: "散料无人值守解决方案",
        fuel: "燃料智能化解决方案",
        unloading: "卸船机AI解决方案",
        inspection: "皮带巡检解决方案",
        coreTech: "核心技术",
      },
    },
    stats: {
      founded: { label: "企业成立", unit: "年", value: 2013 },
      base: { label: "投运项目", unit: "+", value: 200 },
      employee: { label: "年产值", unit: "万", value: 2000 },
      partner: { label: "合作企业", unit: "+", value: 200 },
    },
    rdStats: {
      title: "自主研发核心技术",
      investment: "技术投入占比",
      personnel: "研发人员占比",
      products: "自主研发产品占比",
      experience: "5年行业经验人员占比",
    },
    news: {
      title: "动态中心",
      subtitle: "NEWS CENTER",
      more: "探索更多",
      readMore: "阅读全文",
      list: [
        {
          title: '省级荣誉｜智佳能荣登"2024年广东省制造业500强"榜单！',
          desc: '12月3日，由广东省制造业协会及广东省发展和改革研究院联合主办2024广东省制造业500强峰会在广州举行，会上发布了《2024年广东制造业500强企业研究报告》。智佳能凭借在工业自动化领域领先的技术优势与比亚迪、华为、美的、广汽等知名企业一并荣登"2024年广东省制造业500强"榜单，名列第346位。',
          url: "/news/56",
        },
        {
          title: "50亿项目落地！智佳能荣获2024年度最佳支持奖",
          desc: "近日，智佳能收到来自宁德时代厦门项目基地的喜报，在交付的后段物流自动化生产线项目中，智佳能凭借丰富的项目经验和领先的技术水平以及高效的交付能力，斩获来自宁德时代颁发的2024年最佳支持奖、优秀项目经理以及优秀个人多项殊荣。",
          url: "/news/55",
        },
        {
          title: "智佳能荣获2024年度创新企业奖",
          desc: "智佳能持续创新，荣获2024年度创新企业奖，彰显了公司在智能制造领域的技术实力和行业影响力。作为宁德时代厦门锂电池制造基地一期高速线核心集成商，智佳能展示了卓越的技术实力和自主研发能力。",
          url: "/news/53",
        },
      ],
    },
  },
};
